// extracted by mini-css-extract-plugin
module.exports = {"page":"HomeJobs_page__3LJji","contain":"HomeJobs_contain__3RB-8","pages":"HomeJobs_pages__3A4OK"};